export default __webpack_public_path__ + "static/media/122161.b82f5b50.jpg";